import { isRegion } from "@/lib/regions/client";
import { cableCarStopIds, ferryStopIds } from "@/lib/transitData";

export default function checkStopType(sms) {
  if (sms) {
    if (isRegion("otago")) {
      if (ferryStopIds.includes(String(sms))) {
        return "ferry";
      }

      return "bus";
    }

    if (isRegion("chch")) {
      if (sms === "50823" || sms === "50810") {
        return "ferry";
      }

      return "bus";
    }

    if (isNaN(sms)) {
      if (cableCarStopIds.includes(sms)) {
        return "cable_car";
      } else {
        return "train";
      }
    } else {
      if (sms >= 9995) {
        return "ferry";
      } else {
        return "bus";
      }
    }
  }
  return undefined;
}
